// action validator factory for programmatic access
import { ActionValidationMiddleware, IMarketingCloudUser } from '@ads/iam-library';
import { getCachedEnforcer } from './getCachedEnforcer';

// eslint-disable-next-line import/prefer-default-export
export async function createActionValidator(user: IMarketingCloudUser): Promise<ActionValidationMiddleware> {
    const enforcer = await getCachedEnforcer(user);
    return new ActionValidationMiddleware(enforcer);
}
